import { NavLink } from 'react-router-dom';
import { useT } from '@/i18n/useT';
import { ROUTES } from '@/lib/config';

/**
 * Bottom navigation for the customer's bot screens.
 *
 * Mirrors the five tabs of the operator dashboard so the product feels like one
 * thing, and sits at the bottom because this is used far more on a phone than
 * on a desktop.
 */
const ITEMS = [
  { to: ROUTES.dashboard, key: 'nav.dashboard', icon: 'M3 11l9-8 9 8v9a2 2 0 0 1-2 2h-4v-6H9v6H5a2 2 0 0 1-2-2z' },
  { to: ROUTES.trading, key: 'nav.trading', icon: 'M3 17l6-6 4 4 8-8' },
  { to: ROUTES.strategy, key: 'nav.strategy', icon: 'M4 20V10M10 20V4M16 20v-7M22 20h-20' },
  { to: ROUTES.history, key: 'nav.history', icon: 'M12 8v4l3 2m6-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z' },
  { to: ROUTES.botSettings, key: 'nav.settings', icon: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 7.5 19.4l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.6 1.6 0 0 0 3 14a2 2 0 1 1 0-4 1.6 1.6 0 0 0 1.7-2.6l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 10 3a2 2 0 1 1 4 0 1.6 1.6 0 0 0 2.6 1.7l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1A1.6 1.6 0 0 0 21 10a2 2 0 1 1 0 4 1.6 1.6 0 0 0-1.6 1z' },
] as const;

export function BotNav() {
  const { t } = useT();
  return (
    <nav className="bot-nav" aria-label="Bot">
      {ITEMS.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          className={({ isActive }) => `bot-nav-item${isActive ? ' active' : ''}`}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d={it.icon} />
          </svg>
          <span>{t(it.key)}</span>
        </NavLink>
      ))}
    </nav>
  );
}
